/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BilanCompetenceFichierDto
 */
export interface BilanCompetenceFichierDto {
    /**
     * 
     * @type {number}
     * @memberof BilanCompetenceFichierDto
     */
    idbilanCompetenceFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof BilanCompetenceFichierDto
     */
    idbilanCompetence?: number;
    /**
     * 
     * @type {number}
     * @memberof BilanCompetenceFichierDto
     */
    idfichier?: number;
    /**
     * 
     * @type {number}
     * @memberof BilanCompetenceFichierDto
     */
    idtypeAcquisFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof BilanCompetenceFichierDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the BilanCompetenceFichierDto interface.
 */
export function instanceOfBilanCompetenceFichierDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BilanCompetenceFichierDtoFromJSON(json: any): BilanCompetenceFichierDto {
    return BilanCompetenceFichierDtoFromJSONTyped(json, false);
}

export function BilanCompetenceFichierDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BilanCompetenceFichierDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idbilanCompetenceFichier': !exists(json, 'idbilanCompetenceFichier') ? undefined : json['idbilanCompetenceFichier'],
        'idbilanCompetence': !exists(json, 'idbilanCompetence') ? undefined : json['idbilanCompetence'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'idtypeAcquisFichier': !exists(json, 'idtypeAcquisFichier') ? undefined : json['idtypeAcquisFichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function BilanCompetenceFichierDtoToJSON(value?: BilanCompetenceFichierDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idbilanCompetenceFichier': value.idbilanCompetenceFichier,
        'idbilanCompetence': value.idbilanCompetence,
        'idfichier': value.idfichier,
        'idtypeAcquisFichier': value.idtypeAcquisFichier,
        'fileName': value.fileName,
    };
}

